<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title"><a id="page5"></a>CONTENTS</h1>
<p class="toc-preface" id="toc-ad-card"><span href="#/adcard" title="Link target outside of Sample">By the same author</span></p>
<p class="toc-preface" id="toc-copyright"><span href="#/copyright" title="Link target outside of Sample">Copyright</span></p>
<p class="toc-preface" id="toc-introduction"><a href="#/introduction">Introduction</a></p>
<p class="toc-preface" id="toc-preface004"><a href="#/preface004">Prologue</a></p>
<p class="toc-chapter1" id="toc-chapter000"><a href="#/chapter000">1. Written in Blood</a></p>
<p class="toc-chapter" id="toc-chapter001"><a href="#/chapter001">2. The American Occupation</a></p>
<p class="toc-chapter" id="toc-chapter002"><span href="#/chapter002" title="Link target outside of Sample">3. Papa Doc Comes to Power</span></p>
<p class="toc-chapter" id="toc-chapter003"><span href="#/chapter003" title="Link target outside of Sample">4. Papa Doc, President</span></p>
<p class="toc-chapter" id="toc-chapter004"><span href="#/chapter004" title="Link target outside of Sample">5. The Height of the Terror</span></p>
<p class="toc-chapter" id="toc-chapter005"><span href="#/chapter005" title="Link target outside of Sample">6. Papa Doc’s Final Years</span></p>
<p class="toc-chapter" id="toc-chapter006"><span href="#/chapter006" title="Link target outside of Sample">7. The Revolution Continues</span></p>
<p class="toc-chapter" id="toc-chapter007"><span href="#/chapter007" title="Link target outside of Sample">8. Jeanclaudism, 1977–79</span></p>
<p class="toc-chapter" id="toc-chapter008"><span href="#/chapter008" title="Link target outside of Sample">9. Jean-Claude and Michéle, Honeymoon</span></p>
<p class="toc-chapter" id="toc-chapter009"><span href="#/chapter009" title="Link target outside of Sample">10. Marriage</span></p>
<p class="toc-chapter" id="toc-chapter010"><span href="#/chapter010" title="Link target outside of Sample">11. The Dynasty Falters</span></p>
<p class="toc-chapter" id="toc-chapter011"><span href="#/chapter011" title="Link target outside of Sample">12. The Final Days of Duvalier</span></p>
<p class="toc-chapter" id="toc-chapter012"><span href="#/chapter012" title="Link target outside of Sample">13. The Legacy: Duvalierism Without Duvalier</span></p>
<p class="toc-chapter" id="toc-chapter013"><span href="#/chapter013" title="Link target outside of Sample">14. Passages</span></p>
<p class="toc-chapter" id="toc-chapter014"><span href="#/chapter014" title="Link target outside of Sample">15. Tempests</span></p>
<p class="toc-preface" id="toc-appendix001"><a id="page6"></a><span href="#/appendix001" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc-preface" id="toc-illustration"><span href="#/illustration" title="Link target outside of Sample">Illustration Credits</span></p>
<p class="toc-preface" id="toc-sources"><span href="#/sources" title="Link target outside of Sample">Sources for Chapters 1-13</span></p>
<p class="toc-preface" id="toc-bibliography"><span href="#/bibliography" title="Link target outside of Sample">Select Bibliography</span></p>
<p class="toc-preface" id="toc-endnotes"><span href="#/endnotes" title="Link target outside of Sample">Notes</span></p>
<p class="toc-preface" id="toc-index"><span href="#/index" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?295c2876